<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-overlay :show="loading" rounded="md" variant="transparent">
            <validation-observer ref="detailPostalCodeValidate">
              <b-form ref="detailPostalCodeValidate">
                <b-row>
                  <b-col sm="12" lg="6">
                    <validation-provider
                      #default="{ errors }"
                      :name="t('Zip Code')"
                      rules="required"
                    >
                      <b-form-group label-for="zipcode" :state="errors.length > 0 ? false : null">
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('Zip Code') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <b-form-input
                          id="zipcode"
                          v-model="values.zipcode"
                          name="zipcode"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Zip Code')"
                          :tabindex="9"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="6">
                    <validation-provider
                      #default="{ errors }"
                      :name="t('Country Code')"
                      rules="required"
                      vid="country"
                    >
                      <b-form-group label-for="country" :state="errors.length > 0 ? false : null">
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('Country') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="country"
                          ref="postalCodeCountrySelect"
                          v-model="values.country"
                          :options="countries"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="1"
                          :reduce="option => option.value"
                          @input="handleChangeCountry"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="4">
                    <validation-provider
                      #default="{ errors }"
                      ref="stateValidation"
                      :name="t('State')"
                      rules="required"
                      vid="state_id"
                    >
                      <b-form-group label-for="state" :state="errors.length > 0 ? false : null">
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('State') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="state_id"
                          v-model="values.state_id"
                          :options="states"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="2"
                          :reduce="option => option.value"
                          @input="handleChangeState"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="4">
                    <validation-provider
                      #default="{ errors }"
                      ref="provinceValidation"
                      :name="t('Province')"
                      rules="required"
                      vid="province_id"
                    >
                      <b-form-group
                        label-for="province_id"
                        :state="errors.length > 0 ? false : null"
                      >
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('Province') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="province_id"
                          v-model="values.province_id"
                          :options="cities"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                          :reduce="option => option.value"
                          @input="handleChangeProvince"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col sm="12" lg="4">
                    <b-form-group label-for="province_code" :label="t('Province Code')">
                      <validation-provider #default="{ errors }" :name="t('Province Code')">
                        <b-form-input
                          id="province_code"
                          v-model="values.province_code"
                          name="province_code"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Province Code')"
                          :tabindex="4"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" lg="4">
                    <b-form-group label-for="community" :label="t('Community')">
                      <validation-provider #default="{ errors }" :name="t('Community')">
                        <b-form-input
                          id="community"
                          v-model="values.community"
                          name="community"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Community')"
                          :tabindex="4"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" lg="4">
                    <b-form-group label-for="community_code" :label="t('Community Code')">
                      <validation-provider #default="{ errors }" :name="t('Community Code')">
                        <b-form-input
                          id="community_code"
                          v-model="values.community_code"
                          name="community_code"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Community Code')"
                          :tabindex="8"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" lg="4">
                    <b-form-group label-for="place" :label="t('Place')">
                      <validation-provider #default="{ errors }" :name="t('Place')">
                        <b-form-input
                          id="place"
                          v-model="values.place"
                          name="place"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Place')"
                          :tabindex="5"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-button
                      variant="primary"
                      type="button"
                      class="mt-lg-2"
                      :disabled="submitting"
                      @click="submit"
                    >
                      <feather-icon icon="CheckIcon" size="15" />

                      {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-overlay>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BRow,
  BFormInvalidFeedback
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    vSelect,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider
  },
  mixins: [helper],
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      states: 'app/consignorStates',
      cities: 'app/consignorCities'
    })
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          country: '',
          country_code: '',
          zipcode: '',
          place: '',
          state: '',
          state_code: '',
          state_id: '',
          province: '',
          province_code: '',
          province_id: '',
          community: '',
          community_code: ''
        };
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    setChangeToChange(id) {
      this.handleChangeCountry(id);
    },

    resetStateValues() {
      this.values.state_code = '';
      this.values.state_id = '';
      this.values.state = '';
    },

    resetProvinceValues() {
      this.values.province_id = '';
    },

    handleChangeCountry(id) {
      this.resetStateValues();
      this.resetProvinceValues();

      this.$refs.detailPostalCodeValidate.reset();

      if (id) {
        this.getStateList(id);
      }
    },

    async getStateList(id) {
      this.$store.commit('app/SET_CONSIGNOR_CITIES', []);
      await this.$store.dispatch('app/getConsignorStates', id).then(() => {
        let selectedStateItem = null;

        if (this.values.state_code) {
          selectedStateItem = this.states.find(x => x.stateCode === this.values.state_code);

          if (selectedStateItem) {
            this.values.state_id = selectedStateItem.value;
            this.values.state = selectedStateItem.text;
            this.handleChangeState(selectedStateItem.value);
          }
        }
      });
    },

    handleChangeState(id) {
      this.resetProvinceValues();
      this.$refs.detailPostalCodeValidate.reset();

      const stateItem = this.states.find(x => parseInt(x.value) === parseInt(id));
      if (stateItem) {
        this.values.state = stateItem.text;
        this.values.state_code = stateItem.stateCode;
      }

      if (id) {
        this.getProvinceList(id);
      }
    },

    handleChangeProvince(id) {
      const provinceItem = this.cities.find(x => parseInt(x.value) === parseInt(id));
      if (provinceItem) {
        this.values.province = provinceItem.text;
      }
    },

    async getProvinceList(id) {
      await this.$store
        .dispatch('app/getConsignorCities', {
          countryId: this.values.country,
          cityId: id
        })
        .then(() => {
          let selectedProvinceItem = null;

          if (this.values.province) {
            selectedProvinceItem = this.cities.find(x => x.text === this.values.province);

            if (selectedProvinceItem) {
              this.values.province_id = selectedProvinceItem.value;
              this.handleChangeProvince(selectedProvinceItem.value);
            }
          }
        });
    },

    async submit() {
      this.$refs.detailPostalCodeValidate.validate().then(success => {
        if (success) {
          const {
            community,
            community_code,
            place,
            province,
            province_code,
            state,
            state_code,
            zipcode,
            country
          } = this.values;
          const newValues = {
            community,
            community_code,
            place,
            province,
            province_code,
            state,
            state_code,
            zipcode
          };

          const selectedCountryItem = this.countries.find(
            x => parseInt(x.value) === parseInt(country)
          );

          if (selectedCountryItem) {
            newValues.country_code = selectedCountryItem.iso2;
          }

          this.$emit('submit', newValues);
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
